
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface KnittingPreferencesProps {
  knittingStyle: "continental" | "english" | "not-specified";
  setKnittingStyle: (style: "continental" | "english" | "not-specified") => void;
  measurementSystem: "metric" | "imperial";
  setMeasurementSystem: (system: "metric" | "imperial") => void;
}

export const KnittingPreferences = ({
  knittingStyle,
  setKnittingStyle,
  measurementSystem,
  setMeasurementSystem
}: KnittingPreferencesProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="knittingStyle">Knitting Style</Label>
        <Select 
          value={knittingStyle} 
          onValueChange={(value) => setKnittingStyle(value as "continental" | "english" | "not-specified")}
        >
          <SelectTrigger id="knittingStyle">
            <SelectValue placeholder="Select your knitting style" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="continental">Continental</SelectItem>
            <SelectItem value="english">English</SelectItem>
            <SelectItem value="not-specified">Not Specified</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label>Measurement System</Label>
        <RadioGroup
          value={measurementSystem}
          onValueChange={(value) => setMeasurementSystem(value as "metric" | "imperial")}
          className="flex gap-4"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="metric" id="metric-onboarding" />
            <Label htmlFor="metric-onboarding" className="cursor-pointer">Metric (cm)</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="imperial" id="imperial-onboarding" />
            <Label htmlFor="imperial-onboarding" className="cursor-pointer">Imperial (inches)</Label>
          </div>
        </RadioGroup>
      </div>
    </>
  );
};
